<template>
  <a-modal
    class="change-passwd-modal"
    :title="$t('Header_Change_Password')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("CH_password1")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-group">
      <div class="content-item">
        <InputComponent
          customClass="user-input"
          type="password"
          :title="$t('CH_password2')"
          moduleName="user"
          name="currentPasswd"
          :validation="['required']"
        />
        <div class="error-text">{{ errorMsg }}</div>
      </div>

      <div class="content-item">
        <InputComponent
          customClass="user-input"
          type="password"
          :title="$t('CH_password3')"
          moduleName="user"
          name="newPasswd"
          :validation="['required']"
        />
      </div>

      <div class="content-item">
        <InputComponent
          customClass="user-input"
          type="password"
          :title="$t('CH_password4')"
          moduleName="user"
          name="newPasswdCheck"
          :validation="['required']"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { toRefs, ref, computed, reactive } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl } from "@/utils/common";

import InputComponent from "@/components/commonComponents/InputComponent";

export default {
  name: "ChangePasswdModal",
  components: {
    InputComponent,
  },
  props: {
    visible: Boolean,
    toggleModal: Function,
  },
  setup(props) {
    const store = useStore();
    const state = reactive({
      loading: false,
      enable: true,
      errorMsg: "",
    });
    const inputValues = computed(() => store.getters["user/GET_INPUT_VALUES"]);

    // 필수 항목 입력 여부 체크
    const checkValid = (compareArray) => {
      let enableArray = [];
      compareArray.map((key) => {
        const value = inputValues.value[key];
        if (!!value || value === 0) {
          enableArray.push(key);
        }
      });

      state["enable"] = enableArray.length === compareArray.length;
    };

    // 확인 버튼 이벤트
    const handleOk = async () => {
      state.loading = true;

      const params = {
        currentPasswd: inputValues.value.currentPasswd,
        newPasswd: inputValues.value.newPasswd,
      };

      checkValid(Object.keys(params));
      if (
        inputValues.value.newPasswd === inputValues.value.newPasswdCheck &&
        state["enable"]
      ) {
        try {
          const response = await axios.post(apiUrl + "User/ChangePw", params);
          if (response && !response.data.error) {
            props.toggleModal();
          } else {
            state["errorMsg"] = response.data.error[0].errInfo;
          }
        } catch (error) {
          console.log("add user error", error);
          props.toggleModal();
        }
      }
      state.loading = false;
    };

    const handleCancel = () => {
      props.toggleModal();
    };

    return {
      ...toRefs(state),
      handleOk,
      handleCancel,
    };
  },
};
</script>